import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";

import { VERIFY_AUTH } from "@/modules/together-authentication/store/auth.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);
import VueSlimScroll from "vue-slimscroll";
Vue.use(VueSlimScroll);
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);

// import Lodash
import VueLodash from "vue-lodash";
import lodash from "lodash";

// import resourceful vuex action
import { GENERIC_RESOURCE } from "@/modules/together-helpers/vuex/generic.module";
window.GENERIC_RESOURCE = GENERIC_RESOURCE;

// name is optional
Vue.use(VueLodash, { name: "custom", lodash: lodash });

import VueGtm from "vue-gtm";
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  defer: false,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false
});
// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VueLogger from "vuejs-logger";

//vue-video-player
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
Vue.use(VueVideoPlayer);

//vue-heatmap
import heatmapjsVue from "heatmapjs-vue";
Vue.use(heatmapjsVue);

// Global Components
import Replies from "@/modules/together-helpers/activities/response/Replies";
import Topform from "@/view/components/Topform";
import amChartsExport from "@/view/components/AMChartExport";
import AnonymisedUsername from "@/modules/together-helpers/components/generic-displays/GenericUserName";
import AnonymisedEmail from "@/modules/together-helpers/components/generic-displays/GenericUserEmail";

Vue.component("Replies", Replies);
Vue.component("Topform", Topform);
Vue.component("AMChartsExport", amChartsExport);
Vue.component("AnonymisedUsername", AnonymisedUsername);
Vue.component("AnonymisedEmail", AnonymisedEmail);

// Element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });

// API service init
ApiService.init();

// Vue Logger init
const isProduction = process.env.NODE_ENV === "production";

const options = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};

Vue.use(VueLogger, options);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

// Vue Router init
/* eslint-disable */
router.beforeEach(async (to, from, next) => {
  let proj_client_key = window.location.host.split(".")[0];
  if (to.fullPath.match(/^\/help(?:\/(?=$))?$/i) !== null) {
    let vue3host = process.env.VUE_APP_UPGRADE_URL_SUFFIX;
    let redirectUrl = vue3host + "/#" + to.fullPath;
    if (proj_client_key !== "admin") {
      redirectUrl = process.env.VUE_APP_UPGRADE_URL_SUFFIX + "/#/help/" + proj_client_key;
    }
    window.location.replace(redirectUrl);
  } else if (to.fullPath.match(/^\/register\//i) !== null) {
    let vue3host = process.env.VUE_APP_UPGRADE_URL_SUFFIX;
    let redirectUrl = vue3host + "/#" + to.fullPath;
    window.location.replace(redirectUrl);
  } else if (to.fullPath.match(/^\/reset_password\//i) !== null) {
    let vue3host = process.env.VUE_APP_UPGRADE_URL_SUFFIX;
    let redirectUrl = vue3host + "/#" + to.fullPath;
    window.location.replace(redirectUrl);
  } else {
    let redirectUrl = process.env.VUE_APP_UPGRADE_URL_SUFFIX + "/#/";
    if (proj_client_key !== "admin") {
      redirectUrl = process.env.VUE_APP_UPGRADE_URL_SUFFIX + "/#/sign_in/" + proj_client_key;
    }
    window.location.replace(redirectUrl);
  }

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});
/* eslint-enable */

Vue.filter("stripHTML", function (value) {
  const div = document.createElement("div");
  div.innerHTML = value;
  const text = div.textContent || div.innerText || "";
  return text;
});

//HERE BE DRAGONS - I'm not proud of this, temporary measure until this become a full SPA
window.setInterval(function () {
  if (window.location.hash.length == 0) {
    location.reload();
  }
}, 1000);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");
